
const width = window.innerWidth;

export const mapMaxWidthSearch = () => {

    if (width<=2560 && width > 1920){
        return 300
    }
    if (width<=1920 && width > 1680){
        return 250
    }
    if (width<=1680 && width > 1440){
        return 230
    }
    if (width<=1440 && width > 1366){
        return 200
    }
    return 130
}
